var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"divider push-v--md--x-large",attrs:{"id":"divider"}},[_c('section',{staticClass:"divider--wrapper"},[_c('section',{staticClass:"container"},[_c('h1',{staticClass:"divider--title"},[_vm._v(_vm._s(_vm.title))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }